@if (media) {
  <div class="mdsf-slide h-100"
    >
    <div class="slide-image-container slide-video-container h-100 w-100 p-3">
      @if (!errorState) {
        <video [src]="mediaControlService.getUrl(media)"
          id="video-{{ media.id }}"
          [poster]="mediaControlService.getUrl(media, 'poster')"
          (click)="localToggle()"
          (timeupdate)="updateProgress()"
          (pause)="isPlaying = false"
          (play)="isPlaying = true"
          (loadedmetadata)="setupVideo()"
          (durationchange)="isPlaying = false"
          preload="auto"
          #videoElement>
        </video>
        <div class="video-controls-container">
          <div class="button"
            (click)="localToggle()">
            @if (!isPlaying) {
              <span class="fa fa-fw fa-play"
              ></span>
            }
            @if (isPlaying) {
              <span class="fa fa-fw fa-pause"
              ></span>
            }
          </div>
          <div class="button current-time">
            {{ (slideViewerFacade.currentTime$ | async) * 1000 | date:'mm:ss'  }} / {{ duration() * 1000 | date:'mm:ss'  }}
          </div>
          <div class="button grow">
            <div class="mdsf-progress"
              (mousedown)="localSeekBarMousedown($event)">
              <div class="mdsf-progress-wrap"
                #progressWrap>
                <div class="mdsf-progress-bar"
                  [style.transform]="'scaleX(' + progress + ')'">
                </div>
              </div>
            </div>
          </div>
          <div class="button" ngbDropdown placement="top-right">
            <div id="playback-speed-dropdown" ngbDropdownToggle [ngbTooltip]="('playback_speed' | translate)" placement="top-right">
              <span>{{ speed }}x </span>
              <span class="fa fa-gauge"></span>
            </div>
            <div ngbDropdownMenu aria-labelledby="playback-speed-dropdown">
              @for (sp of playbackSpeed; track sp) {
                <button ngbDropdownItem
                  (click)="adjustPlaybackSpeed(sp)"
                  [class.active]="sp === speed"
                  >
                  {{ sp }}x
                </button>
              }
            </div>
          </div>
          <div class="button" [class.active]="loop" [ngbTooltip]="('endless_loop' | translate)" placement="top-right" (click)="toggleEndlessLoop()">
            <span class="fa fa-rotate"></span>
          </div>
        </div>
      }
    </div>
  </div>
}

